import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { TelephoneOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TelephoneOutlined";
import { dispatchNewEvent } from "@/utils/analytics/trigger/analyticsTrigger";
import OpeningHours from "../opening-hours/OpeningHours";
import { ContactDetailsContext } from "../../../../context/contact-details-context";
import styles from "./contact-phone.module.scss";

function ContactPhone({ className, showNumber, title, config: { number, displayTimes } }) {
  const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);
  const [numberShown, setNumberShown] = useState(showNumber);

  const handleShowNumber = () => {
    setNumberShown(true);
    dispatchNewEvent("dataStateChange", {
      action: "contactUsDecisionSolutionReveal",
      type: window.jlData.page.decisionTree.refinement,
      solutionType: `partner:${number.replace(/ /g, "")}`,
    });
  };

  const numberClicked = () => {
    dispatchNewEvent("dataStateChange", {
      action: "contactUsDecisionSolution",
      type: window.jlData.page.decisionTree.refinement,
      solutionType: `partner:${number.replace(/ /g, "")}`,
    });
  };

  return (
    <div
      className={classnames(className, { [styles["contact-phone"]]: liveChatProminenceExperiment })}
      data-test="container-phone"
    >
      <h4 className={liveChatProminenceExperiment && styles["contact-phone__title"]}>
        {liveChatProminenceExperiment ? "Call us" : "Phone"}
      </h4>
      <div className={styles["contact-phone__title-text"]}>
        {liveChatProminenceExperiment ? (
          <>
            <p>Speak to one of our Partners.</p>
            <p>If you have an order number, please have it to hand.</p>
          </>
        ) : (
          <p>{title}</p>
        )}
      </div>
      <div className={styles["contact-phone__number-desktop"]} data-test="contact-phone-number-desktop">
        {numberShown ? (
          <div className={styles["contact-phone__number-box"]} data-test="contact-phone-number-box">
            {liveChatProminenceExperiment && <TelephoneOutlined />}
            {number}
          </div>
        ) : (
          <SecondaryButton onClick={handleShowNumber}>Call us</SecondaryButton>
        )}
      </div>
      <div className={styles["contact-phone__number-mobile"]}>
        <SecondaryButton tag="a" onClick={numberClicked} href={`tel:${number.replace(/ /g, "")}`}>
          {liveChatProminenceExperiment && <TelephoneOutlined />}
          {number}
        </SecondaryButton>
      </div>
      <OpeningHours openingHours={displayTimes} />
    </div>
  );
}

ContactPhone.propTypes = {
  config: PropTypes.shape({
    number: PropTypes.string,
    open: PropTypes.bool,
    closedMessage: PropTypes.string,
    displayTimes: PropTypes.arrayOf(
      PropTypes.shape({
        order: PropTypes.number,
        days: PropTypes.string,
        times: PropTypes.string,
      }),
    ),
    supplierNumber: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  showNumber: PropTypes.bool,
  title: PropTypes.string,
};

ContactPhone.defaultProps = {
  className: undefined,
  showNumber: true,
  title: "Speak to one of our Partners and have your order number ready, if you have one.",
};

export default ContactPhone;
